import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { ANDatePicker } from "@answersnow/pkg-theme";

interface LabeledDatePickerProps {
  label: string;
  value: Date | null;
  onChange: (value: Date | null) => void;
  helperText?: string;
  disableFuture?: boolean;
  disablePast?: boolean;
  format?: string;
  onBlur?: React.FocusEventHandler;
  id?: string;
  slotProps?: Record<string, unknown>;
}

export const LabeledDatePicker: React.FC<LabeledDatePickerProps> = ({
  label,
  value,
  onChange,
  helperText,
  disableFuture,
  disablePast,
  format = "PP",
  onBlur,
  id,
  slotProps,
}) => {
  return (
    <Grid item xs={12}>
      <Stack gap={1}>
        <ANDatePicker
          id={id}
          label={label}
          value={value}
          onChange={onChange}
          format={format}
          disableFuture={disableFuture}
          disablePast={disablePast}
          onBlur={onBlur}
          slotProps={slotProps}
          sx={{ width: "100%" }}
        />
        {helperText && (
          <Typography
            variant="inputLabel"
            sx={{ color: "var(--grey-600, #798397)", fontWeight: 400 }}
          >
            {helperText}
          </Typography>
        )}
      </Stack>
    </Grid>
  );
};

export default LabeledDatePicker;
